// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g>
				<path
					d="M16.757 2.99998L14.757 4.99998H5V19H19V9.24298L21 7.24298V20C21 20.2652 20.8946 20.5195 20.7071 20.7071C20.5196 20.8946 20.2652 21 20 21H4C3.73478 21 3.48043 20.8946 3.29289 20.7071C3.10536 20.5195 3 20.2652 3 20V3.99998C3 3.73476 3.10536 3.48041 3.29289 3.29287C3.48043 3.10533 3.73478 2.99998 4 2.99998H16.757V2.99998ZM20.485 2.09998L21.9 3.51598L12.708 12.708L11.296 12.711L11.294 11.294L20.485 2.09998V2.09998Z"
					fill={props.color}
				/>
			</g>
		</svg>
	</>
);

export default Icon;
